
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seleccion",
      function () {
        return require("private-next-pages/seleccion.js");
      }
    ]);
  